import React, { useState } from 'react'; // Eliminamos 'useRef' de la importación
//import HistoryItemView from './HistoryItemDraggable'; // Usamos la versión no arrastrable
import './Sidebar.css';

// --- Interfaces para las props (SIMPLIFICADAS) ---
//interface HistoryItem {id: string;title: string;}

// Eliminamos la interface 'FolderData' que ya no se usa
// interface FolderData { id: string; name: string; items: HistoryItem[]; }

interface SidebarProps {
  className?: string; // 1. Aceptar una prop 'className' opcional
  isHistoryLoading: boolean;
  historyList: any[]; // ajusta este tipo si es necesario
  username: string;
  onNewChat: () => void;
  onSelectChat: (id: string) => void;
  onProfileClick: () => void;
}

// --- Componente Principal de la Sidebar (SIMPLIFICADO) ---
const Sidebar: React.FC<SidebarProps> = (props) => {
  // 2. Desestructurar 'className' de las props
  const { className, isHistoryLoading, historyList, username, onNewChat, onSelectChat, onProfileClick } = props;
  const [searchTerm, setSearchTerm] = useState('');

  const filteredHistory = historyList.filter(item => 
    item.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    // 3. Aplicar la clase al div principal del sidebar
    <div className={className || 'sidebar'}>
      <div className="sidebar-header">
        <button className="new-chat-btn" onClick={onNewChat}>💬 Nuevo chat</button>
        <input
          type="search"
          placeholder="Buscar en el historial..."
          className="search-input"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
      <div className="chat-history">
        {isHistoryLoading ? (
          <div className="chat-history-item">Cargando historial...</div>
        ) : (
          <>
            {filteredHistory.map(item => (
              <div
                key={item.id}
                className="chat-history-item"
                onClick={() => onSelectChat(item.id)}
              >
                {item.title}
              </div>
            ))}
          </>
        )}
      </div>
      <div className="user-profile" onClick={onProfileClick}>
        👤 {username}
      </div>
    </div>
  );
};

export default Sidebar;